import moment from "moment-jalaali";
import { useEffect } from "react";

export const generate_uuid = () => {
  var dt = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
};
export const toJalali = (date, format = "jYYYY-jMM-jDD") => {
  try {
    return toPersianDigits(moment(date).format(format));
  } catch {
    return "error parsing date";
  }
};

export const toDatePicker = (date, format = "YYYY-MM-DDTHH:mm:ss") => {
  try {
    return moment(date).format(format);
  } catch {
    return moment();
  }
};

export const dateTimeToserver = (date, format = "YYYY-MM-DD HH:mm:ss") => {
  try {
    return moment(date).format(format);
  } catch {
    return moment();
  }
};
const toPersianDigits = (value) => {
  const charCodeZero = "۰".charCodeAt(0);
  return String(value).replace(/[0-9]/g, (w) =>
    String.fromCharCode(w.charCodeAt(0) + charCodeZero - 48)
  );
};

export const transformTranslateFromValues = (values) => {
  let _values = { translates: [] };

  for (const [key, value] of Object.entries(values)) {
    if (key.startsWith("_")) {
      const t_info = key.substring(1).split("*");
      _values["translates"] = [
        ..._values["translates"],
        {
          language: t_info[0],
          attribute: t_info[1],
          type: t_info[2],
          value,
        },
      ];
    } else {
      _values[key] = value;
    }
  }
  return _values;
};
export const transformTranslateServerValues = (values) => {
  let _values = {};

  for (const [key, value] of Object.entries(values)) {
    if (key === "translates") {
      for (const item of value) {
        _values["_" + item.language + "*" + item.attribute + "*" + item.type] =
          item.value;
      }
    } else {
      _values[key] = value;
    }
  }
  return _values;
};

export function useClickDetecter(ref, cb) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        cb(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [cb, ref]);
}

export function objectFilter(hystack, alloewd_keys) {
  return Object.keys(hystack)
    .filter((key) => alloewd_keys.includes(key))
    .reduce((obj, key) => {
      obj[key] = hystack[key];
      return obj;
    }, {});
}
